import { render, staticRenderFns } from "./study_old.vue?vue&type=template&id=30d3fa89&scoped=true&"
import script from "./study_old.vue?vue&type=script&lang=js&"
export * from "./study_old.vue?vue&type=script&lang=js&"
import style0 from "./study_old.vue?vue&type=style&index=0&id=30d3fa89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3fa89",
  null
  
)

export default component.exports